import React, { useState } from "react";
import "./App.css";

const logo = process.env.PUBLIC_URL + "/CGA Logo.png";
const sculpture = process.env.PUBLIC_URL + "/Old man.jpg";
const painting = process.env.PUBLIC_URL + "/Resilience.jpg";
const digital =
  process.env.PUBLIC_URL + "/ritratto_generativo_FINALE_ QUADRATO.png";
const books = process.env.PUBLIC_URL + "/Distilled_Books.png";
const audio =
  process.env.PUBLIC_URL + "/The_Art_of_Distilling_Time.mp3";

const pdfPreviews = {
  RIVER: process.env.PUBLIC_URL + "/RIVER.pdf",
  DIGNITY: process.env.PUBLIC_URL + "/DIGNITY.pdf",
  "FADING LOVE": process.env.PUBLIC_URL + "/FADING LOVE.pdf",
  ADAPTATION: process.env.PUBLIC_URL + "/ADAPTATION.pdf",
  "SESSO SBAGLIATO":
    process.env.PUBLIC_URL + "/SESSO SBAGLIATO.pdf",
  BITUMINOSA: process.env.PUBLIC_URL + "/BITUMINOSA.pdf",
  "BROKEN DOLLS":
    process.env.PUBLIC_URL + "/BROKEN_DOLLS.pdf",
  VETTE: process.env.PUBLIC_URL + "/VETTE.pdf",
};

const bookLinks = {
  RADICE:
    "https://www.amazon.com/gp/product/B0H2KS3JL3?ref_=dbs_m_mng_rwt_calw_tkin_2&storeType=ebooks",
  RESTARE:
    "https://www.amazon.com/gp/product/B0GY3Z4Q1K?ref_=dbs_m_mng_rwt_calw_tkin_1&storeType=ebooks",
  INTENZIONE:
    "https://www.amazon.com/gp/product/B0HCVHR6SS?ref_=dbs_m_mng_rwt_calw_tkin_0&storeType=ebooks",
};

const authorLink = "https://www.amazon.com/author/claudiogobber";

function ImageModal({ src, alt, onClose }) {
  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <img
        src={src}
        alt={alt}
        className="max-w-3xl max-h-[90vh] rounded shadow-lg"
        onClick={(e) => e.stopPropagation()}
      />
    </div>
  );
}

function DistilledBooksSection({ onClose }) {
  return (
    <section className="w-full max-w-5xl mt-8 mb-12 border-t border-neutral-300 pt-10">
      <div className="text-center mb-8">
        <p className="text-sm tracking-[0.25em] uppercase text-neutral-500 mb-2">
          Distilled Books
        </p>

        <h2 className="text-3xl md:text-4xl font-bold mb-2">
          DISTILLARE IL TEMPO
        </h2>

        <p className="text-lg italic text-neutral-600">
          3 Books · Italian Edition
        </p>
      </div>

      <div className="flex justify-center mb-10">
        <img
          src={books}
          alt="Distillare il Tempo book series"
          className="w-full max-w-xl rounded shadow-lg"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left mb-12">
        <div className="border border-neutral-200 rounded p-6 shadow-sm">
          <h3 className="text-xl font-bold mb-1">RADICE</h3>

          <p className="text-sm italic text-neutral-500 mb-4">
            Distillare il Tempo
          </p>

          <p className="text-neutral-700 mb-6">
            Un attraversamento personale fatto di materiali,
            memoria, silenzio, permanenza e trasformazione.
            Un'esplorazione del rapporto tra tempo, presenza e
            ciò che continua a restare vivo quando il rumore si
            deposita.
          </p>

          <a
            href={bookLinks.RADICE}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-blue-600 font-semibold hover:underline"
          >
            VIEW ON AMAZON
          </a>
        </div>

        <div className="border border-neutral-200 rounded p-6 shadow-sm">
          <h3 className="text-xl font-bold mb-1">RESTARE</h3>

          <p className="text-sm italic text-neutral-500 mb-4">
            Distillare il Tempo
          </p>

          <p className="text-neutral-700 mb-6">
            Non un metodo e non una teoria, ma frammenti,
            situazioni reali e piccoli gesti. Respirare. Stare
            fermi. Fare un passo. Abbastanza per attraversare i
            momenti in cui tutto sembra cedere.
          </p>

          <a
            href={bookLinks.RESTARE}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-blue-600 font-semibold hover:underline"
          >
            VIEW ON AMAZON
          </a>
        </div>

        <div className="border border-neutral-200 rounded p-6 shadow-sm">
          <h3 className="text-xl font-bold mb-1">INTENZIONE</h3>

          <p className="text-sm italic text-neutral-500 mb-4">
            L'importanza di comprendere la propria direzione
          </p>

          <p className="text-neutral-700 mb-6">
            Un attraversamento tra lavoro, identità, paura,
            presenza, contributo e tempo. Una riflessione sulla
            differenza tra un obiettivo da raggiungere e
            l'intenzione profonda che ci porta a muoverci.
          </p>

          <a
            href={bookLinks.INTENZIONE}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block text-blue-600 font-semibold hover:underline"
          >
            VIEW ON AMAZON
          </a>
        </div>
      </div>

      <div className="max-w-3xl mx-auto text-left border-t border-neutral-200 pt-8">
        <h3 className="text-2xl font-bold mb-4 text-center">
          About the Author
        </h3>

        <p className="text-neutral-700 leading-relaxed mb-4">
          Claudio Gobber is an Italian author, artist and
          entrepreneur who has spent much of his life at the
          intersection of seemingly opposite worlds. Business
          and art, city and mountain, action and contemplation,
          belonging and solitude all coexist in his work.
          Rather than choosing between them, he is interested
          in the territory that appears where they meet.
        </p>

        <p className="text-neutral-700 leading-relaxed mb-4">
          His books explore time, memory, identity, intention,
          work and the objects and places through which we give
          meaning to our lives. His writing grows from lived
          experience, moving freely between entrepreneurial
          life, artistic practice and personal reflection.
        </p>

        <p className="text-neutral-700 leading-relaxed mb-8">
          Claudio lives and works in Trentino, Italy.
        </p>

        <div className="text-center">
          <a
            href={authorLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block border border-neutral-900 px-6 py-3 font-semibold tracking-wide hover:bg-neutral-900 hover:text-white transition-colors"
          >
            EXPLORE ALL BOOKS ON AMAZON
          </a>
        </div>
      </div>

      <div className="text-center mt-8">
        <button
          type="button"
          onClick={onClose}
          className="text-neutral-500 hover:text-neutral-900 underline"
        >
          Close Distilled Books
        </button>
      </div>
    </section>
  );
}

function HomePage() {
  const [modalImage, setModalImage] = useState(null);
  const [showBooks, setShowBooks] = useState(false);

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center p-8 text-center text-neutral-900 font-sans">
      {modalImage && (
        <ImageModal
          src={modalImage.src}
          alt={modalImage.alt}
          onClose={() => setModalImage(null)}
        />
      )}

      <img
        src={logo}
        alt="Claudio Gobber Logo"
        className="w-24 h-24 mb-6"
      />

      <h1 className="text-5xl md:text-6xl font-bold mb-2">
        CLAUDIO GOBBER ART
      </h1>

      <p className="text-xl md:text-2xl italic text-neutral-700">
        The Art of Distilling Our Time
      </p>

      <div className="mb-8">
        <label className="text-sm block text-neutral-700">
          Soundtrack: The Art of Distilling Time
        </label>

        <audio
          src={audio}
          autoPlay
          muted
          controls
          className="mt-1"
          style={{
            backgroundColor: "#000",
            borderRadius: "4px",
          }}
        />
      </div>

      <div className="flex flex-wrap justify-center gap-6 mb-2">
        <div className="flex flex-col items-center">
          <img
            src={sculpture}
            alt="Sculpture Example"
            className="w-64 rounded shadow-lg cursor-pointer"
            onClick={() =>
              setModalImage({
                src: sculpture,
                alt: "Sculpture Example",
              })
            }
          />

          <div className="mt-2 text-center font-semibold text-lg uppercase tracking-wide">
            SCULPTURE
          </div>
        </div>

        <div className="flex flex-col items-center">
          <img
            src={painting}
            alt="Painting Example"
            className="w-64 rounded shadow-lg cursor-pointer"
            onClick={() =>
              setModalImage({
                src: painting,
                alt: "Painting Example",
              })
            }
          />

          <div className="mt-2 text-center font-semibold text-lg uppercase tracking-wide">
            PAINTINGS
          </div>
        </div>

        <div className="flex flex-col items-center">
          <img
            src={digital}
            alt="Digital Art Example"
            className="w-64 rounded shadow-lg cursor-pointer"
            onClick={() =>
              setModalImage({
                src: digital,
                alt: "Digital Art Example",
              })
            }
          />

          <div className="mt-2 text-center font-semibold text-lg uppercase tracking-wide">
            DISTILLED CODE
          </div>
        </div>

        <div className="flex flex-col items-center">
          <img
            src={books}
            alt="Distilled Books"
            className="w-64 rounded shadow-lg cursor-pointer"
            onClick={() => setShowBooks(!showBooks)}
          />

          <div
            className="mt-2 text-center font-semibold text-lg uppercase tracking-wide cursor-pointer"
            onClick={() => setShowBooks(!showBooks)}
          >
            DISTILLED BOOKS
          </div>
        </div>
      </div>

      {showBooks && (
        <DistilledBooksSection
          onClose={() => setShowBooks(false)}
        />
      )}

      <div className="max-w-3xl text-left space-y-4 mb-10">
        <p>
          Claudio Gobber, born in Trentino, Italy, is a sculptor,
          painter, photographer, and designer blending traditional
          techniques with digital experimentation. After a career
          spanning Milan, London, Switzerland, and Spain, he
          returned to Trentino where his practice deepened with
          clay, driftwood, and generative art.
        </p>

        <p>
          Inspired by artists like Riccardo Schweizer, Simone
          Turra, and Giuliano Orsingher, Claudio’s mission is to
          create time capsules—works that challenge, move, and
          enlighten. His art explores humanity’s deepest questions
          and themes such as dignity, adaptation, love, and legacy.
        </p>

        <p>
          Exhibitions include Artexpo New York, LA Art Show,
          Spectrum Miami, and the Washington Biennale. His
          installations integrate sculpture, sound, light, and
          scent to offer multisensory experiences.
        </p>
      </div>

      <div className="mb-12">
        <h2 className="text-2xl font-semibold mb-4">
          Key Projects
        </h2>

        <ul className="list-none grid grid-cols-1 md:grid-cols-2 gap-8">
          {Object.entries(pdfPreviews).map(([title, url]) => (
            <li
              key={title}
              className="border p-4 rounded shadow-sm"
            >
              <h3 className="text-lg font-bold mb-2">
                {title}
              </h3>

              <div className="hidden md:block">
                <iframe
                  src={url}
                  title={`Preview of ${title}`}
                  className="w-full h-48 border"
                ></iframe>
              </div>

              <div className="mt-2">
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-600 hover:underline"
                >
                  View Full PDF
                </a>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="flex flex-wrap justify-center gap-6 text-blue-600 text-lg">
        <a
          href="https://www.instagram.com/claudio_gobber_"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Instagram
        </a>

        <a
          href="https://x.com/ClaudioxGobber?s=03"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          X (Twitter)
        </a>

        <a
          href="mailto:claudio.x.gobber@gmail.com"
          className="hover:underline"
        >
          Email
        </a>

        <a
          href="https://www.youtube.com/@CLAUDIOGOBBERART-m7c/featured"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          YouTube
        </a>

        <a
          href="https://open.spotify.com/intl-it/artist/5Cxfoo7ffS9waTtIy3nRzy?si=wgI51K9mS5u-zi5Ax4CLxA"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:underline"
        >
          Spotify
        </a>
      </div>
    </div>
  );
}

function App() {
  return <HomePage />;
}

export default App;